import React from 'react';

export function useUpdateEffect(fn: any, deps?: any[]) {
  const didMountRef = React.useRef(false);

  React.useEffect(() => {
    if (didMountRef.current) fn();
    else didMountRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
